(function() {

	var Application = include("springroll.Application"),
		Container = include("PIXI.Container"),
		Positioner = include("springroll.Positioner"),
		Point = include("PIXI.Point");

	var Joke = function(state, config)
	{
		this.state = state;

		Container.call(this);

		this.hitArea = Positioner.generateHitArea(config.hitArea);
		this.vo = config.vo;

		this.hoverTimer = 0;
		
		this.isOver = false;

		this.update = this.update.bind(this);
		this.onMouseOver = this.onMouseOver.bind(this);
		this.onMouseOut = this.onMouseOut.bind(this);
	};

	// Extend MovieClip
	var s = Container.prototype;
	var p = Joke.prototype = Object.create(s);
	
	var helperPoint = new Point();

	p.enable = function()
	{
		this.interactive = true;
		
		var game = Application.instance;
		if(game.hasTouch)
			game.on("update", this.update);
		else
			this.on("mouseover", this.onMouseOver);
	};
	
	p.disable = function()
	{
		this.interactive = false;
		
		var game = Application.instance;
		game.off("update", this.update);
		this.off("mouseover", this.onMouseOver);
		this.off("mouseout", this.onMouseOut);
	};

	p.onMouseOver = function()
	{
		this.isOver = true;

		var game = Application.instance;
		this.hoverTimer = game.config.game.clues.jokeHoverTime;
		
		if(!game.hasTouch)
		{
			game.on("update", this.update);
			this.on("mouseout", this.onMouseOut);
		}
	};

	p.update = function(elapsed)
	{
		//jokes might get one update after destroy() but before the Application
		//removes the update listener properly
		if(!this.state) return;
		
		var game = Application.instance;
		if(game.hasTouch)
		{
			//do our own mouseover checking
			var cursor = game.cursor;
			var spawnPos = game._sparkles.spawnPos;
			var localPos = Point.localToLocal(game.cursor, this, spawnPos.x, spawnPos.y,
												helperPoint);
			if(this.hitArea.contains(localPos.x, localPos.y))
			{
				if(!this.isOver)
				{
					this.isOver = true;
					this.onMouseOver();
				}
			}
			else if(this.isOver)
			{
				this.onMouseOut();
			}
		}
		
		if(!this.isOver) return;
		
		this.hoverTimer -= elapsed;
		if(this.hoverTimer <= 0)
		{
			if(this.state.playVO(this.vo))
			{
				this.interactive = false;
				this.buttonMode = false;
				this.onMouseOut();
			}
		}
	};

	p.onMouseOut = function()
	{
		this.off("mouseout", this.onMouseOut);
		this.isOver = false;
		var game = Application.instance;
		if(!game.hasTouch || !this.interactive)
			game.off("update", this.update);
	};

	p.destroy = function()
	{
		s.destroy.call(this);
		Application.instance.off("update", this.update);
		this.onMouseOut = this.onMouseOver = this.update = this.state = this.hitArea = null;
	};

	namespace('heist').Joke = Joke;
}());